<template>
  <div
    v-if="totalPages > 1"
    class="custom-pagination gap-1 justify-center items-center"
  >
    <CustomPaginationButton
      :label="$t('First')"
      :is-disabled="isFirstPage"
      @click="() => onPageChange(PAGINATION_ACTIONS.FIRST)"
    />
    <CustomPaginationButton
      :label="$t('Previous')"
      :is-disabled="isFirstPage"
      :is-arrow-button="true"
      class="iconify svg--chevron-left"
      @click="() => onPageChange(PAGINATION_ACTIONS.PREV)"
    />
    <template v-for="pageNumber in displayedPages">
      <CustomPaginationButton
        v-if="pageNumber >= startPage"
        :key="pageNumber"
        :label="pageNumber"
        :is-selected="currentPage === pageNumber"
        :is-disabled="currentPage === pageNumber"
        @click="() => onPageChange(PAGINATION_ACTIONS.PAGE, pageNumber)"
      />
    </template>
    <CustomPaginationButton
      :label="$t('Next')"
      :is-disabled="currentPage === totalPages"
      :is-arrow-button="true"
      class="iconify svg--chevron-right"
      @click="() => onPageChange(PAGINATION_ACTIONS.NEXT)"
    />
    <CustomPaginationButton
      :label="$t('Last')"
      :is-disabled="currentPage === totalPages"
      @click="() => onPageChange(PAGINATION_ACTIONS.LAST)"
    />
  </div>
</template>

<script lang="ts">

import { PAGINATION_ACTIONS, PAGINATION_DEFAULT_RESULTS_LIMIT } from '~~/constants/pagination';
import type { PaginationActions } from '~~/constants/pagination';
import { createArrayBasedOnStartEndPoint } from '~~/helpers/arrays/createArrayBasedOnStartEndPoint';

export default defineComponent({
  name: 'CustomPagination',

  props: {
    totalResultsAmount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: PAGINATION_DEFAULT_RESULTS_LIMIT,
    },
  },
  emits: ['onPageChange'],
  setup(props, { emit }) {

    const {
      currentPage,
      totalPages,
      getChangePageParams,
      startPage,
      endPage,
    } = usePagination(props.totalResultsAmount, props.perPage);
    const displayedPages = computed(() => createArrayBasedOnStartEndPoint(startPage.value, endPage.value));

    const onPageChange = (action: PaginationActions, page?: number) => {

      const pageChangeParams = getChangePageParams(action, page);
      emit('onPageChange', pageChangeParams);
    
    };

    const isFirstPage = computed(() => currentPage.value === 1);

    return {
      getChangePageParams,
      currentPage,
      totalPages,
      displayedPages,
      PAGINATION_ACTIONS,
      onPageChange,
      isFirstPage,
      startPage,
      endPage,
    };
  
  },
});

</script>
